<template>
  <v-card class="nx-seo-metas-wizard">
    <v-card-title class="title pb-0 px-4" primary-title>{{ $t('message.seo.metas.wizard.title') }}</v-card-title>

    <v-card-text class="py-0 px-0">
      <v-layout>
        <v-flex class="xs12 px-5 pt-1">
          <v-text-field
            label="Name"
            name="name"
            :disabled="isDisabled('name')"
            v-model="draft.name"
          >
          </v-text-field>
          <v-text-field
            label="Property"
            name="property"
            :disabled="isDisabled('property')"
            v-model="draft.property"
          >
          </v-text-field>
          <v-text-field
            label="Charset"
            name="charset"
            :disabled="isDisabled('charset')"
            v-model="draft.charset"
          >
          </v-text-field>
          <v-text-field
            label="httpEquiv"
            name="httpEquiv"
            :disabled="isDisabled('httpEquiv')"
            v-model="draft.httpEquiv"
          >
          </v-text-field>
          <v-text-field
            label="Content"
            name="content"
            v-model="draft.content"
          >
          </v-text-field>
          <v-text-field
            label="Id"
            name="id"
            v-model="draft.id"
          >
          </v-text-field>

          <div v-if="withApplyTo">
            <v-subheader class="px-0 mx-0">{{ $t('message.seo.metas.applyTo.label') }}</v-subheader>
            <v-layout>
              <v-flex class="xs-6">
                <v-switch v-model="applyTo"
                          small
                          :label="$t('message.seo.metas.applyTo.contents')"
                          value="contents">
                </v-switch>
                <v-switch v-model="applyTo"
                          :label="$t('message.seo.metas.applyTo.pages')"
                          value="pages">
                </v-switch>
              </v-flex>
              <v-flex class="xs-6">
                <v-switch v-model="applyTo"
                          :label="$t('message.seo.metas.applyTo.descendantTaxonContents')"
                          value="descendantTaxonContents">
                </v-switch>
                <v-switch v-model="applyTo"
                          :label="$t('message.seo.metas.applyTo.descendantTaxonPages')"
                          value="descendantTaxonPages">
                </v-switch>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" small flat @click="close">
        {{ $t("message.seo.metas.wizard.buttons.cancel") }}
      </v-btn>

      <v-btn
        color="secondary"
        small
        flat
        @click="create"
        :disabled="disabled">
        {{ $t("message.seo.metas.wizard.buttons.accept") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { omit } from 'lodash';

export default {
  name: 'nx-seo-metas-wizard',
  props: {
    value: {
      type: Object,
    },
    withApplyTo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      applyTo: [],
      draft: this.value || {},
    };
  },
  computed: {
    disabled() {
      if (this.withApplyTo
        && this.applyTo.length === 0) {
        return true;
      }
      return this.uniqueAttributes.every(attribute => !this.draft[attribute]);
    },
    /**
     * Meta unique valid attributes
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta
     */
    uniqueAttributes() {
      return [
        'id',
        'name',
        'httpEquiv',
        'property',
        'charset',
      ];
    },
  },
  methods: {
    init() {
      this.reset();
      if (!this.value) {
        return;
      }
      if (this.withApplyTo && this.value.applyTo) {
        this.applyTo = [this.value.applyTo];
      }
      this.draft = omit(this.value, ['applyTo', 'origin']);
    },
    isDisabled(field) {
      if (this.draft[field]) {
        return false;
      }
      return this.uniqueAttributes.some(attribute => this.draft[attribute]);
    },
    reset() {
      this.draft = {};
      this.applyTo = [];
    },
    close() {
      this.reset();
      this.$emit('cancel');
    },
    create() {
      // Emit the result
      // We need an array of individual metas. One for each applyTo selected
      if (this.withApplyTo) {
        this.$emit('input', this.applyTo.map(to => Object.assign(omit(this.draft, ['uuid']), { applyTo: to })));
      } else {
        this.$emit('input', [Object.assign(omit(this.draft, ['uuid']))]);
      }
      this.close();
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    value() {
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-seo-metas-wizard {
  &__content {
    min-height: 300px;
  }
}
</style>
